<template>
  <slot />
</template>

<script lang="ts" setup>
import { usePostHog } from '#/shared/composables/use-posthog';
// import ReatomDevtools from './reatom-devtools.vue';
// import { sentryBrowserConfig } from "../../sentry.browser.config";

// sentryBrowserConfig();

usePostHog();
</script>

<style>
@import "./tailwind.css";
@import "primeicons/primeicons.css";

body {
  margin: 0;
  font-family: sans-serif;
  background-color: #F7F6F4;
}
* {
  box-sizing: border-box;
}
a {
  text-decoration: none;
}

#app {
  position: relative;
}

h1 {
  font-size: 1.5rem;
  font-weight: 600;
}
</style>
<!-- 
<style scoped>
.layout {
  display: flex;
  max-width: 900px;
  margin: auto;
}
.content {
  padding: 20px;
  padding-bottom: 50px;
  min-height: 100vh;
  flex-grow: 1;
}
/* Page Transition Animation */
#page-content {
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
}
body.page-is-transitioning #page-content {
  opacity: 0;
}
</style> -->
